import { LayoutGrid, Home, Sparkles, Clapperboard, MessageCircle, User, Plus, LogOut, Film } from "lucide-react";
import MisteckMark from "@/components/brand/MisteckMark";

// Permanent left navigation rail — DESKTOP ONLY (md:+). Locked in place; mirrors
// the mobile BottomNav zones plus a Command/Deck entry and Create dispatch. It
// drives AppShell's existing `view` state (no remount) so the workspace never
// reloads when switching panes. Fully hidden below md — mobile is untouched.
const ZONES = [
  { key: "command", label: "DECK", icon: LayoutGrid },
  { key: "feed", label: "FEED", icon: Home },
  { key: "alix", label: "ALIX", icon: Sparkles },
  { key: "reels", label: "REELS", icon: Clapperboard },
  { key: "editor", label: "EDIT", icon: Film },
  { key: "chat", label: "CHAT", icon: MessageCircle },
  { key: "me", label: "ME", icon: User },
];

export default function DesktopNavRail({ view, setView, onCreate, onLogout, socialUnread = 0 }) {
  return (
    <nav
      data-testid="desktop-nav-rail"
      className="hidden md:flex fixed left-0 top-0 z-[60] h-screen w-20 flex-col items-center border-r-4 border-gold/80 bg-charcoal py-5"
    >
      <div className="mb-4 w-11 h-11 grid place-items-center overflow-hidden rounded-xl" data-testid="rail-brand-logo">
        <MisteckMark size={44} />
      </div>

      <div className="flex-1 flex flex-col items-center gap-1.5 w-full px-1.5">
        {ZONES.map((z) => {
          const Icon = z.icon;
          const active = view === z.key;
          return (
            <button
              key={z.key}
              onClick={() => setView(z.key)}
              data-testid={`desktop-rail-${z.key}`}
              className={[
                "relative w-full flex flex-col items-center gap-1 py-2.5 border-2 transition-colors duration-200",
                active ? "border-gold bg-gold/10" : "border-transparent hover:border-white/20",
              ].join(" ")}
            >
              <Icon size={20} strokeWidth={2.2} className={active ? "text-gold" : "text-white/55"} />
              <span className={["font-mono text-[8px] tracking-[0.16em]", active ? "text-gold" : "text-white/45"].join(" ")}>{z.label}</span>
              {z.key === "chat" && socialUnread > 0 && (
                <span
                  data-testid="desktop-rail-chat-badge"
                  className="absolute top-1 right-2 min-w-[15px] h-[15px] px-1 rounded-full bg-red-600 text-white border border-charcoal grid place-items-center font-mono text-[8px] font-black"
                >
                  {socialUnread}
                </span>
              )}
            </button>
          );
        })}
      </div>

      <button
        onClick={onLogout}
        data-testid="desktop-rail-logout"
        className="mt-3 w-full flex flex-col items-center gap-1 py-2 text-white/40 hover:text-red-400 transition-colors"
      >
        <LogOut size={17} />
        <span className="font-mono text-[8px] tracking-[0.16em]">EXIT</span>
      </button>
    </nav>
  );
}
